export const MIN_CARD_DIMENSIONS = {
  width: 384,
  height: 482,
};
